var map = {
	"./capacitacion-profesional-enfermeria-edomex.png": 14,
	"./curso-masoterapia-profesional-edomex.png": 8507,
	"./curso-rehabilitacion-fisica-ixtapaluca.png": 1998,
	"./cursos-enfermeria-quiropractica-nican.png": 7574,
	"./diplomado-quiropractica-fundacion-nican.png": 2275,
	"./estudiantes-practica-enfermeria-fundacion-nican.png": 4366,
	"./graduacion-certificacion-laboral-ixtapaluca.png": 1828,
	"./practicas-fisioterapia-fundacion-nican.png": 9307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2461;